import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import * as serviceWorkerRegistration from './serviceWorkerRegistration';
import "./Component/Static/Css/all.min.css"
import "./Component/Static/Css/Normalize.css"
import "./Component/Static/Css/main.css"
import { DatacontextProvader } from './Component/Context/Allcontext';
import { AuthProvader } from './Component/AuthContext/AuthContext';
import {BrowserRouter} from "react-router-dom"

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <AuthProvader>
    <DatacontextProvader>
      <BrowserRouter>
      <App />
      </BrowserRouter>
    </DatacontextProvader>
    </AuthProvader>
  </React.StrictMode>
);


serviceWorkerRegistration.register();
